export default __webpack_public_path__ + "static/media/TNAA-marquee-neon6.d0183d5a.jpg";